import { useCallback, useMemo, useState } from 'react';

export type UseSingleDayPickerStateResult = {
    date?: Date;
    isDaySelected: (day: { from: Date; to: Date }) => boolean;
    onDaySelected: (day: { from: Date; to: Date }) => void;
    clear: () => void;
};

export const useSingleDayPickerState = (initialValue?: Date): UseSingleDayPickerStateResult => {
    const [date, setDate] = useState<Date | undefined>(initialValue);

    const isDaySelected = useCallback(
        (day: { from: Date; to: Date }) => {
            if (!date) {
                return false;
            }
            return date.getTime() >= day.from.getTime() && date.getTime() < day.to.getTime();
        },
        [date]
    );

    const onDaySelected = useCallback(
        (day: { from: Date; to: Date }) => {
            setDate(day.from);
        },
        [setDate]
    );

    const clear = useCallback(() => {
        setDate(undefined);
    }, [setDate]);

    const result = useMemo(() => {
        return {
            date,
            isDaySelected,
            onDaySelected,
            clear,
        };
    }, [date, isDaySelected, onDaySelected, clear]);

    return result;
};
